import React from "react"
import styled from "styled-components"

import { Typography } from "@material-ui/core"

import HeroImage from "../HeroImage"
import Textarea from "../textarea"

import * as theme from "../../theme"
import IoAnimator from "../IoAnimator"

const Cards = ({ cards }) => {
  return (
    <Container>
      {!!cards &&
        cards.map(
          (
            {
              headline,
              description,
              featured_image: { url: img, alt },
              featured_image
            },
            index
          ) => {
            return (
              <IoAnimator
                key={index}
                animation={index % 2 === 0 ? "fadeInRight" : "fadeInLeft"}
                threshold={0.1}
              >
                <Card>
                  {!!featured_image && (
                    <PhotoBox>
                      <CardImage alt={alt} bg={img} />
                    </PhotoBox>
                  )}
                  <Info>
                    {!!headline && (
                      <Headline variant="h2" gutterBottom>
                        {headline}
                      </Headline>
                    )}
                    {!!description && <Textarea content={description} />}
                  </Info>
                </Card>
              </IoAnimator>
            )
          }
        )}
    </Container>
  )
}

export default Cards

Cards.defaultProps = { animationTime: 0.6 }

const Container = styled.div`
  margin-top: -60px;
  z-index: 10;
  position: relative;
`

const Card = styled.div`
  @media (min-width: 1000px) {
    flex-direction: row;
    margin: 20px 40px;
  }
  margin: 20px;
  flex-direction: column;
  display: flex;
  background: white;
  border-radius: 8px;
  transition: opacity 400ms ease-in-out;
  will-change: transform, opacity;
`

const Info = styled.div`
  @media (min-width: 1000px) {
    padding: 50px 30px;
  }
  padding: 30px;
`

const Headline = styled(Typography)`
  color: ${theme.color.primary};
`

const PhotoBox = styled.div`
  min-height: 225px;
  @media (max-width: 999px) {
    height: 24vw;
  }
  @media (min-width: 1000px) {
    width: 20vw;
    border-radius: 8px 0 0 8px;
    /* min-width: 25vw; */
    min-width: 200px;
  }
  @media (min-width: 1000px) {
    min-width: 300px;
  }
  border-radius: 8px 8px 0 0;
  position: relative;
  background: lightgrey;
  /* max-width: 250px; */
`
const CardImage = styled(HeroImage)`
  @media (min-width: 1000px) {
    border-radius: 8px 0 0 8px;
  }
  border-radius: 8px 8px 0 0;
`
